export const mapErrorCodeToMessage = (errorCode: string | undefined) => {
  switch (errorCode) {
    case 'CARD_DECLINED':
      return 'Your card was declined. Please check your card details and try again.'
    case 'CARD_EXPIRED':
      return 'Your card has expired. Please update your payment method.'
    case 'AUTHENTICATION_REQUIRED':
      return 'Authentication is required for this payment method. Please complete the authentication and try again.'
    case 'PAYMENT_DECLINED':
      return 'Your payment was declined. Please try a different card or contact your bank for more information.'
    case 'PAYMENT_METHOD_UNSUPPORTED':
      return 'The payment method you are using is not supported. Please use a different payment method.'
    default:
      return undefined
  }
}
